import React from 'react';
import {
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PersonIcon from '@mui/icons-material/Person';
import LockResetIcon from '@mui/icons-material/LockReset';
import { toast } from 'react-toastify';
import useMediaQuery from '@mui/material/useMediaQuery';


import HomeIcon from '@mui/icons-material/Home';
import BusinessIcon from '@mui/icons-material/Business';
import ListIcon from '@mui/icons-material/List';
import BarChartIcon from '@mui/icons-material/BarChart';
import SettingsIcon from '@mui/icons-material/Settings';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import EventIcon from '@mui/icons-material/Event';

const drawerWidth = 256;

const menuItems = [
  { id: 'dashboard', label: 'Dashboard', icon: HomeIcon },
  { id: 'add-property', label: 'Add Property', icon: BusinessIcon },
  { id: 'my-properties', label: 'My Properties', icon: ListIcon },
   { id: 'bookings-calendar', label: 'Bookings Calendar', icon: EventIcon },
  
   { id: 'payments', label: 'Payment Details', icon: AccountBalanceIcon },

 
  {
    id: 'settings',
    label: 'Settings',
    icon: SettingsIcon,
    children: [
     
      { id: 'security', label: 'Password & Security', icon: LockResetIcon },
    ],
  },
  { id: 'help', label: 'Help & Support', icon: HelpOutlineIcon },
   { id: 'logout', label: 'Logout', icon: ExitToAppIcon },
];

export function VendorSidebar({
  activeTab,
  onTabChange,
  variant,
  mobileOpen,
  onMobileClose,
  disabled = false, 
}) {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:600px)');
  const [open, setOpen] = React.useState(false);
const [settingsOpen, setSettingsOpen] = React.useState(false);

  const handleClick = (id) => {
     if (disabled) {
    toast.error('Your account is suspended. Navigation is blocked.');
    return; 
  }

  if (id === 'logout') {
    localStorage.removeItem('vendorToken');
    navigate('/vendor/login');
  } else {
    onTabChange(id);
  }
    if (isMobile) setOpen(false);
  };

  const drawerContent = (
    <Box sx={{ overflow: 'auto', pt: 8 }}>
      <List>
{menuItems.map((item) => {
  const Icon = item.icon;

 
  if (item.children) {
    return (
      <React.Fragment key={item.id}>
        <ListItemButton
          onClick={() => setSettingsOpen(!settingsOpen)}
          sx={{ mx: 1, borderRadius: 1 }}
        >
          <ListItemIcon sx={{ minWidth: 36 }}>
            <Icon />
          </ListItemIcon>
          <ListItemText primary={item.label} />
        </ListItemButton>

        {settingsOpen &&
          item.children.map((child) => {
            const ChildIcon = child.icon;

            return (
              <ListItemButton
                key={child.id}
                selected={activeTab === child.id}
                onClick={() => handleClick(child.id)}
                sx={{ pl: 6, mx: 1, borderRadius: 1 }}
              >
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <ChildIcon />
                </ListItemIcon>
                <ListItemText primary={child.label} />
              </ListItemButton>
            );
          })}
      </React.Fragment>
    );
  }

 
  return (
    <ListItemButton
      key={item.id}
      selected={activeTab === item.id && !disabled}
      onClick={() => !disabled && handleClick(item.id)}
      disabled={disabled}
      sx={{ mx: 1, borderRadius: 1 }}
    >
      <ListItemIcon sx={{ minWidth: 36 }}>
        <Icon />
      </ListItemIcon>
      <ListItemText primary={item.label} />
    </ListItemButton>
  );
})}

      </List>
    </Box>
  );

  if (variant === 'mobile' && isMobile) {
    return (
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onMobileClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            bgcolor: 'grey.100',
          },
        }}
      >
        {drawerContent}
      </Drawer>
    );
  }

  if (variant === 'desktop' && !isMobile) {
    return (
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            bgcolor: 'grey.100',
            borderRight: 1,
            borderColor: 'divider',
          },
        }}
      >
        {drawerContent}
      </Drawer>
    );
  }

  return null;
}
